import { render, staticRenderFns } from "./AllocationDateModal.vue?vue&type=template&id=4ef290a9&scoped=true&style=top%3A%2020px"
import script from "./AllocationDateModal.vue?vue&type=script&lang=ts"
export * from "./AllocationDateModal.vue?vue&type=script&lang=ts"
import style0 from "./AllocationDateModal.vue?vue&type=style&index=0&id=4ef290a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef290a9",
  null
  
)

export default component.exports